import React from 'react';
import { Box } from '@wix/design-system';
import { WixStudioLogo } from '../../imgs/WixStudioLogo';

export function Header() {
  return (
    <Box height="48px" direction="horizontal" align="space-between">
      <Box verticalAlign="middle" padding="12px 24px">
        <WixStudioLogo />
      </Box>
    </Box>
  );
}

export default Header;
